import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleAircraftUtilization } from "./Constant/Source";
import AircraftUtilizationCreateForm from "./Forms/AircraftUtilizationCreateFrom";
import { useHistory } from "react-router-dom";
import AircraftUtilizationTTCreateForm from "./Forms/AircraftUtilizationTTCreateForm";
import { useAuth } from "@airborne/react-admin";

const AircraftUtilizationCreate: FC<CreateProps> = props => {
  const history = useHistory();
  const { user } = useAuth();

  const RedirectToList = () => {
    history.push("/aircraftutilizations");
  };

  if (user?.isCustomer === true) {
    return (
      <Create {...props} title={TitleAircraftUtilization.create} onSuccess={RedirectToList}>
        <SimpleForm>
          <AircraftUtilizationCreateForm />
        </SimpleForm>
      </Create>
    );
  } else {
    return (
      <Create {...props} title={TitleAircraftUtilization.create} onSuccess={RedirectToList}>
        <SimpleForm>
          <AircraftUtilizationTTCreateForm />
        </SimpleForm>
      </Create>
    );
  }
};

export default AircraftUtilizationCreate;
